// extracted by mini-css-extract-plugin
module.exports = {"preferences":"Preferences-module--preferences--1U4RO"};